<template>
	<div>
		<h4 class="section-title">Course Detail</h4>

		<div class="container">
			<div class="profile-presentation mb-5">
	            <div class="row">
	            	<div class="col" v-if="course_data != null">

	            		<p>Course title: {{ course_data.name }}</p>
	            		<p>Course description: {{ course_data.description }}</p>

	            		<p>Modules</p>
	            		<ul>
	            			<li v-for="module in course_data.modules">
	            				<div>{{ module.name}}</div>

	            				<div>Lessons</div>
	            				<ul>
	            					<li v-for="lesson in module.lessons">
	            						{{ lesson.name }}
	            					</li>
	            				</ul>
	            			</li>
	            		</ul>
	            		
	            	</div>
	                
	            </div><!--row-->
	        </div><!--profile_presentation-->
	    </div>
	    
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			course_data : null
		}
	},

	created : function(){
		this.getCourse();
		
	},

	methods : {
		getCourse : function(){

			var params = {
				id : this.id,
				filters : {
					full : true
				}
			}

			this.$store.dispatch('getCourse', params).then((res) => {
				this.course_data = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/sme/courses/SMECourseDetailComponent.vue